"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentBillGroup = void 0;
exports.paymentBillGroup = { "RET": { "name": "Retail", "transactionCode": "R" }, "PTN": { "name": "Partnership", "transactionCode": "P" }, "GRP": { "name": "Group voluntary", "transactionCode": "G" }, "MOB": { "name": "Mobile application", "transactionCode": "A" }, "AGN": { "name": "Agency", "transactionCode": "N" } };
